import { useState, useEffect } from 'react'

const getHeight = () => document.querySelector('footer')?.clientHeight
  || 180

function useFooterHeight() {
  const [footerHeight, setFooterHeight] = useState(getHeight())
  useEffect(() => {
    let timeoutId: any = undefined
    const resizeListener = () => {
      clearTimeout(timeoutId)
      timeoutId = setTimeout(() => setFooterHeight(getHeight()), 150)
    }
    window.addEventListener('resize', resizeListener)

    return () => {
      window.removeEventListener('resize', resizeListener)
    }
  }, [])

  return footerHeight
}

export default useFooterHeight
